import React from "react";
import Oversight from "../../assets/TasksImages/Oversight.png"
import Procedure from "../../assets/TasksImages/Procedure.png";
import Documentation from "../../assets/TasksImages/Documentation.png";
import Coordination from "../../assets/TasksImages/Coordination.png";
import Compliance from "../../assets/TasksImages/Compliance.png";
import Info from "../../assets/TasksImages/Info.png";
import TFSReview from "../../assets/TasksImages/TFSReview.png";
import Safety from "../../assets/TasksImages/Safety.png";
import InServiceCheck from "../../assets/TasksImages/InServiceCheck.png";
import {Col} from "react-flexbox-grid";


const sectionStyle = {
    width: '20px',
    height: '20px',
};

const PROCEDURE = "Procedure.png";
const DOCUMENTATION ="Documentation.png";
const COORDINATION ="Coordination.png"
const COMPLIANCE ="Compliance.png"
const INFO ="Info.png"
const REVIEW ="Review.png"
const SAFETY ="Safety.png"
const SERVICE ="Service.png"
const OVERSIGHT ="Oversight.png"


const  TaskImages = ({imageName}) => {


    switch(imageName){
        case PROCEDURE:
            return  (
                <Col lg={1} md={2} xs={2}><img src={Procedure} style={sectionStyle}/></Col>)

        case DOCUMENTATION:
            return (
                <Col lg={1} md={2} xs={2}><img src={Documentation} style={sectionStyle}/></Col>)

        case COORDINATION:
            return (
                <Col lg={1} md={2} xs={2}><img src={Coordination}  style={sectionStyle}/></Col>)

        case COMPLIANCE:
            return(
              <Col lg={1} md={2} xs={2}><img src={Compliance}  style={sectionStyle}/></Col>)

        case INFO:
            return (
                <Col lg={1} md={2} xs={2}><img src={Info}  style={sectionStyle}/></Col>)

        case REVIEW:
            return(
                <Col lg={1} md={2} xs={2}><img src={TFSReview}  style={sectionStyle}/></Col>)

        case SAFETY:
            return(
                <Col lg={1} md={2} xs={2}><img src={Safety}  style={sectionStyle}/></Col>)

          case SERVICE:
             return(
                 <Col lg={1} md={2} xs={2}><img src={InServiceCheck}  style={sectionStyle}/></Col>)

        case OVERSIGHT:
            return(
                <Col lg={1} md={2} xs={2}><img src={Oversight}  style={sectionStyle}/></Col>)

        default:
            return (  <Col lg={1} md={2} xs={2}> { ' '}</Col>)
    }

};
export default TaskImages;